/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createIsPrime } from '../../factoriesAny.js';
export var isPrimeDependencies = {
  typedDependencies: typedDependencies,
  createIsPrime: createIsPrime
};